(function () {
  const container = document.querySelector("#plugin-catalog-container");
  if (!container) {
    return;
  }

  const searchBox = document.querySelector("#plugin-search-box");
  const resultsEl = container.querySelector(".results");
  const cards = Array.from(document.querySelectorAll(".plugin-cards .card-tile"));

  function applyFilters() {
    const query = searchBox.value.toLowerCase().trim();
    let count = 0;

    cards.forEach((card) => {
      const matchesSearch = !query || card.dataset.title.includes(query) || card.dataset.desc.includes(query) || card.dataset.tags.includes(query) || card.dataset.author.includes(query);

      if (matchesSearch) {
        card.style.display = "";
        count++;
      } else {
        card.style.display = "none";
      }
    });

    resultsEl.textContent = count === 1 ? "1 result" : `${count} results`;
  }

  searchBox.addEventListener("input", applyFilters);
  applyFilters();

  // Mark all internal categories, and put them at the beginning.
  const tags = document.querySelectorAll(".card-category");
  tags.forEach((tag) => {
    if (tag.textContent.includes("Internal")) {
      tag.classList.add("internal");
    }
  });
})();
